import { gettext } from '@core/lib/utils/localization';

export default [
  {
    name: gettext('feature.cost-data'),
    key: 'cost_data',
    required_package: null,
    available: true,
    enabled: true
  },
  {
    name: gettext('feature.ad-revenue-data'),
    key: 'ad_revenue',
    required_package: 'ad_revenue',
    available: true,
    enabled: true
  },
  {
    name: gettext('feature.revenue-data'),
    key: 'revenue_data',
    required_package: null,
    available: true,
    enabled: true
  }
];
